import React from 'react';
import { useTranslation } from 'react-i18next';
import { MAILING_TOPICS } from '../services/mailingService';

/** Checkbox per mailing topic (rifas / eventos / newsletter). */
const MailingTopicsField = ({ value, onChange, disabled = false }) => {
  const { t } = useTranslation('mailing');
  const toggle = (topic) => {
    const next = value.includes(topic) ? value.filter((v) => v !== topic) : [...value, topic];
    onChange(MAILING_TOPICS.filter((v) => next.includes(v)));
  };
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.6rem' }}>
      {MAILING_TOPICS.map((topic) => (
        <label key={topic} style={{ display: 'flex', alignItems: 'flex-start', gap: '0.6rem', cursor: disabled ? 'default' : 'pointer', fontSize: '0.95rem', color: '#333', lineHeight: 1.4 }}>
          <input
            type="checkbox"
            checked={value.includes(topic)}
            onChange={() => toggle(topic)}
            disabled={disabled}
            style={{ width: 18, height: 18, marginTop: 1, flexShrink: 0, cursor: disabled ? 'default' : 'pointer' }}
          />
          <span>
            <strong>{t(`topics.${topic}.label`)}</strong>
            <span style={{ display: 'block', color: '#777', fontSize: '0.85rem' }}>{t(`topics.${topic}.hint`)}</span>
          </span>
        </label>
      ))}
    </div>
  );
};

export default MailingTopicsField;
